const indexData = [
  {
    title: '暑期观影指南',
    desc: '精选六大平台最热片单',
    icon: 'ri-sun-line',
    count: '36部推荐',
    color: 'primary',
  },
  {
    title: '新平台速览',
    desc: '近期上线及即将接入的平台介绍',
    icon: 'ri-rocket-line',
    count: '5家新平台',
    color: 'accent',
  },
  {
    title: '高清专区',
    desc: '支持4K与1080P高清播放的平台汇总',
    icon: 'ri-4k-line',
    count: '8家平台',
    color: 'primary',
  },
  {
    title: '原创内容档案',
    desc: '各平台独家原创系列作品目录',
    icon: 'ri-file-copy-line',
    count: '42个系列',
    color: 'secondary',
  },
  {
    title: '社区热门讨论',
    desc: '91视频等平台本周最热话题精选',
    icon: 'ri-chat-1-line',
    count: '28个话题',
    color: 'accent',
  },
  {
    title: '技术观察',
    desc: '播放器、CDN与画质优化技术趋势',
    icon: 'ri-cpu-line',
    count: '12篇分析',
    color: 'secondary',
  },
  {
    title: '行业数据月报',
    desc: '各平台月度访问量与内容增长统计',
    icon: 'ri-bar-chart-line',
    count: '7月更新',
    color: 'primary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            主题导航
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按主题分类整理的影视平台内容索引，帮助您快速定位感兴趣的领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                item.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                item.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium">{item.count}</span>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4).map((item, idx) => (
            <a
              key={idx + 4}
              href="#cards"
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                item.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                item.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}